import {createAsyncThunk} from '@reduxjs/toolkit'

import {eq} from '@shared/helpers/lang'

import {FDSPhase, FDSPhaseType, FDS_AUTH_LEVEL} from '@web/core/constants'
import {FDSRejectionReason, FDSRejectionReasonType, FdsState, FDSStatus, FDSStatusType} from '@web/slices/fds/slice'

import {isFdsInfoValid} from './../validators'

export type RootState = {
    fds: FdsState
}

type ThunkApi = {
    state: RootState
    rejectValue: FDSRejectionReasonType
}

const isBlockUser = eq(FDS_AUTH_LEVEL.BLOCK)
const isSelfLimitExceeded = eq(FDS_AUTH_LEVEL.SELF_BLOCK)

/** 현재 FDS 정보에 따라 진행가능한 상태로 fds process를 진행시킵니다 */
const processFDS = createAsyncThunk<{phase: FDSPhaseType; status: FDSStatusType}, void, ThunkApi>(
    'processFds/processFds',
    (_, {getState, rejectWithValue}) => {
        const {fds} = getState()

        // fds info가 fds process 진행에 필요한 만큼 갖춰지지 않음
        if (!isFdsInfoValid(fds) || !fds.authentication) {
            return rejectWithValue(FDSRejectionReason.FDS_INFO_REQUIRED)
        }

        const {
            authentication: {level},
        } = fds

        // 차단 유저
        if (isBlockUser(level)) {
            return rejectWithValue(FDSRejectionReason.BLOCK)
        }

        // 유저 설정 결제한도 초과
        if (isSelfLimitExceeded(level)) {
            return rejectWithValue(FDSRejectionReason.SELF_BLOCK)
        }

        return {
            phase: FDSPhase.PROCESSING,
            status: FDSStatus.PENDING,
        }
    },
)

export default processFDS
